import styled, { css } from 'react-emotion';
import theme from '@lyearn-team/theme-config';
import { withTheme } from 'emotion-theming';

export const CompanyPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  align-items: center;
  box-sizing: border-box;
  &.pageWrapper {
    @media (min-width: 767px) {
      padding: 53px 55px 57px;
      width: 503px;
      height: 463px;
    }
    background-color: ${theme.color.dark.saturn};
    @media (max-width: 767px) {
      padding: 80px 16px 20px;
      width: 100%;
      height: 100%;
    }
  }
`;

export const closeButton = css`
  fill: white;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const FixWidthColumn = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-top: 10px;

  @media (max-width: 767px) {
    flex-grow: 1;
    justify-content: space-between;
  }
`;

export const PrivacyPolicyLink = withTheme(styled.div`
  ${({ theme: { color } }) => `
    position: fixed;
    left: 50px;
    bottom: 20px;
    @media (max-width: 767px) {
      position: inherit;
      margin-top: 50px;
    }
    a {
      cursor: pointer;
      text-decoration: underline;
      color: ${color.accent};
      font-size: 14px;
      :hover {
        color: ${color.black2};
      }
    }
  `};
`);

export const SearchInputWrapper = styled.div`
  width: 100%;
  margin-right: 4px;
`;

export const IntroText = styled.span`
  font-size: 12px;
  line-height: 1;
  color: ${theme.color.dark.iron};
  margin-top: 80px;
  align-self: flex-start;
  letter-spacing: 2px;

  @media (max-width: 767px) {
    width: 100%;
    margin-top: 40px;
  }
`;

export const textButton = css`
  margin-top: auto;

  @media (max-width: 767px) {
    margin-top: 40px;
  }
`;

export const inputClass = css`
  padding: 10px 20px;
  width: 100%;

  @media (max-width: 767px) {
    text-align: left;
  }
`;

export const buttonClass = css`
  width: 100%;
  margin-top: 28px;
  line-height: 16px;
  padding: 10px 16px;
  @media (max-width: 767px) {
    margin-top: 0px;
  }
`;

export const FixText = styled.div`
  font-size: 14px;
  color: ${theme.color.dark.silver};
`;

export const CloseButton = withTheme(styled.div`
  ${({ theme: { color } }) => `
  color: ${color.black3};
  
  cursor: pointer;
  text-align: right;
  font-size: 20px;
  width: 425px;
  @media (max-width: 767px) {
    float: right;
    width: auto;
    align-self: flex-end;
    text-align: right;
    position: fixed;
    z-index: 5;
    margin-top: -20px;
    padding: 0 20px 0 0;
  }
  
  `};
`);

export const FixMargin = styled.div`
  @media (max-width: 767px) {
    height: 60px;
  }
`;

export const DescriptionContainer = withTheme(styled.div`
  ${({ theme: { color } }) => `
    p {
      padding: 0px 0px 25px;
      font-size: 16px;
      color: ${color.black2};
      font-weight: 300;
      margin: 0px;
    }
  `};
`);
